import { throttle } from "./Util";

let rangeInputChanged = false;
let initialFormValues = [];

if (App.H.hasClass("page-catalog")) {
    document.addEventListener("keypress", function (e) {
        const key = e.which || e.keyCode;
        if (key === 13 && e.target.getAttribute("tabindex") !== null) {
            // код клавиши Enter
            $(e.target).trigger("click");
        }
    });

    if ($(".js-catalog-form").length && $(".js-catalog-form-submit").length) {
        App.H.on("click", ".js-catalog-form-submit", function (e) {
            e.preventDefault();

            if ($(this).is(".js-sticky-filter-submit")) {
                $(this).removeClass("_shown");
            }

            submitCatalogFilter();
        });
    }

    if ($(".js-sorting").length) {
        App.H.on("change", ".js-sorting-radio input", function (e) {
            submitCatalogFilter();
            e.preventDefault();
        });
    }

    if ($(".js-price-input").length) {
        App.H.on("change keyup input click", ".js-price-input", function () {
            if (
                $(this)
                    .val()
                    .match(/[^0-9]/g)
            ) {
                $(this).val(
                    $(this)
                        .val()
                        .replace(/[^0-9]/g, ""),
                );
            }
        });
    }

    if ($(".js-filter-content").length) {
        App.H.on("change", ".js-filter-content input:not(.js-price-input):not(.js-range-input)", function () {
            updateCatalogFilter();
        });
    }

    if ($(".js-filter-city-reset").length) {
        $(".js-filter-city-reset").on("click", function () {
            updateCatalogFilter();
        });
    }

    App.H.on("click", ".js-active-filter", function (e) {
        e.preventDefault();

        $(".js-filter")
            .find(`input[name="${$(this).data("name")}"][value="${$(this).data("value")}"]`)
            .prop("checked", false);
        $(".js-filter")
            .find(`input[name="${$(this).data("name")}"][type="text"]`)
            .val("");
        updateCatalogFilter();
        submitCatalogFilter();
    });
}

App.H.on(
    "input",
    ".js-range-input",
    throttle(function () {
        App.lastCatalogChangedLine = $(this).closest(".js-filter-price");
        updateCatalogFilter();
    }, 500),
);

App.H.on(
    "input",
    ".js-filter-block-search",
    throttle(function () {
        const $searchInput = $(this);
        const $filterParent = $searchInput.closest(".js-filter-block");
        const $list = $filterParent.find(".filter-block__line");

        $list.each(function () {
            $(this).addClass("_hidden");

            if ($(this).find("label").text().toLowerCase().indexOf($searchInput.val().toLowerCase()) >= 0) {
                $(this).removeClass("_hidden");
            }
        });

        if ($list.length === $filterParent.find(".filter-block__line._hidden").length) {
            $filterParent.find(".js-filter-block-search-empty").removeClass("_hidden");
        } else {
            $filterParent.find(".js-filter-block-search-empty").addClass("_hidden");
        }
    }, 500),
);

function updateCatalogFilter() {
    const $filter = $(".js-filter");
    const $catalogFormButton = $(".js-catalog-form-submit");
    const $catalogFormButtonReset = $(".js-catalog-filter-reset");

    $catalogFormButton.prop("disabled", true);

    // Разлочиваем все disabled фильтры для актуализации
    $filter.find('input[type="checkbox"], input[type="radio"]').attr("disabled", false);

    $.ajax({
        url: $filter.data("url"),
        method: $filter.data("method") || "get",
        data: serializeFormData($filter.find("input")),
        success: function (data) {
            if (data.success) {
                Object.keys(data.inputs).forEach((inputsName) => {
                    Object.keys(data.inputs[inputsName]).forEach((inputValue) => {
                        let $inputWrapper;
                        const $input = $filter.find(`input#${inputValue}`);

                        if ($input.closest(".js-filter-checkbox").length) {
                            $inputWrapper = $input.closest(".js-filter-checkbox");
                        } else {
                            $inputWrapper = $input.closest(".js-filter-radio");
                        }

                        /*** check it ****/
                        if (data.inputs[inputsName][inputValue] <= 0) {
                            if (inputsName !== App.document.currFilter) {
                                $inputWrapper.closest(".filter-block__line").addClass("_hidden-filter");
                                $inputWrapper.addClass("_disabled");

                                if ($input.is(":checked")) {
                                    $input.attr("disabled", true);
                                }
                            }
                        } else {
                            $inputWrapper.closest(".filter-block__line").removeClass("_hidden-filter");
                            $inputWrapper.removeClass("_disabled");

                            if ($input.is(":checked")) {
                                $input.attr("disabled", false);
                            }
                        }

                        $inputWrapper.find(".note").text(`(${data.inputs[inputsName][inputValue]})`);

                        /*if (data.inputs[inputsName][inputValue] <= 0) {
                            $inputWrapper.closest('.filter-block__line').hide();
                            $inputWrapper.addClass('_disabled');
                        } else {
                            $inputWrapper.closest('.filter-block__line').show();
                            $inputWrapper.removeClass('_disabled');
                        }
                        $inputWrapper.find('.note').text(`(${data.inputs[inputsName][inputValue]})`);*/
                        /*** check it ****/

                    });
                });

                if (App.lastCatalogChangedLine.length) {
                    setFilterStickyButtonPosition(App.lastCatalogChangedLine);
                }
            } else {
                console.log("error");
            }
            $catalogFormButton.prop("disabled", false);

            if ($(".js-filter").find("input:checked").length > 0 || rangeInputChanged) {
                $catalogFormButtonReset.removeClass("_disabled");
            } else {
                $catalogFormButtonReset.addClass("_disabled");
            }
        },
    });
}

function submitCatalogFilter() {
    const $catalogForm = $(".js-catalog-form");
    const $catalogFormButton = $(".js-catalog-form-submit");
    const catalogView = $(".js-catalog-view-toggle._active").data("view");

    $catalogFormButton.prop("disabled", true);
    $.ajax({
        url: $catalogForm.attr("action"),
        method: $catalogForm.attr("method") || "get",
        data: serializeFormData($catalogForm),
        success: function (data) {
            if (data.success) {
                $catalogForm
                    .find(".js-catalog-cards")
                    .removeClass("_rows _grid")
                    .addClass("_" + catalogView);

                if (data.redirect_url) {
                    window.history.replaceState({}, "", data.redirect_url);
                }
                if (data.catalog_top) {
                    $catalogForm.find(".js-catalog-top").html("").append(data.catalog_top);
                    $catalogForm.find(".js-catalog-view-toggle").removeClass("_active");
                    $catalogForm
                        .find(`.js-catalog-view-toggle[data-view="${catalogView}"]`)
                        .addClass("_active");
                }
                if (data.active_filters && data.active_filters.length > 0) {
                    $catalogForm.find(".js-active-filters").html("").append(data.active_filters);
                } else {
                    $catalogForm.find(".js-active-filters").html("");
                }
                if (data.pagination && data.pagination.length > 0) {
                    $catalogForm.find(".js-pagination").html("").append(data.pagination);
                } else {
                    $catalogForm.find(".js-pagination").html("");
                }
                if (data.catalog_cards) {
                    $catalogForm.find(".js-catalog-cards").html("").append(data.catalog_cards);
                }
                // if ($('.js-main-product-slider').length) {
                //     initSwiperInProduct();
                // }

                // Прячем окно фильтров после применения
                $(".js-catalog-wrapper._filter-opened").each((i, filterModalDom) => {
                    $(filterModalDom).removeClass("_filter-opened");
                    App.lockScroll.unlock();
                });
            } else {
                if (data.out_of_range) {
                    const url = window.location;
                    const params = new URLSearchParams(url.search);
                    params.delete("page");
                    const newUrl = window.location.origin + window.location.pathname + "?" + params;

                    window.location.href = newUrl;
                } else {
                    console.log("error");
                    $catalogForm.find(".js-catalog-cards").html("").append(data.message);
                    $catalogForm.find(".js-pagination").html("");
                }
            }
            $catalogFormButton.prop("disabled", false);
        },
        error: function (jqXHR) {
            if (jqXHR.status == 404) {
                if (jqXHR.responseJSON.out_of_range) {
                    const url = window.location;
                    const params = new URLSearchParams(url.search);
                    params.delete("page");
                    const newUrl = window.location.origin + window.location.pathname + "?" + params;

                    window.location.href = newUrl;
                }
            }
        },
    });
}

App.H.find(".js-range-slider").each(function () {
    initRangeSlider($(this));
});
App.H.on("keyup", ".js-range-input", function () {
    let $rangeWrap = $(this).closest(".js-filter-block");
    let inputValue = removeSpaces($(this).val());
    let $rangeSlider = $rangeWrap.find(".js-range-slider");
    let range = $rangeSlider.data("ionRangeSlider");

    // Проверяем, является ли ввод числом
    if (!/^\d+$/.test(inputValue)) {
        $(this).val(formatTextWithSpaces($(this).data("lastValid") ?? $(this).attr("value"))); // Возвращаем предыдущее значение
        return;
    }

    if (range) {
        const key = $(this).hasClass("js-range-from") ? "from" : "to";
        range.update({ [key]: inputValue });
    }

    $(this).val(formatTextWithSpaces(inputValue));
    $(this).data("lastValid", inputValue); // Сохраняем последнее корректное значение
});
App.H.on("blur", ".js-range-input", function () {
    let $rangeWrap = $(this).closest(".js-filter-block");
    let $rangeSlider = $rangeWrap.find(".js-range-slider");
    let range = $rangeSlider.data("ionRangeSlider");
    let $inputFrom = $rangeWrap.find(".js-range-from");
    let $inputTo = $rangeWrap.find(".js-range-to");
    const sliderMaxValue = $rangeSlider.data("max");

    const inputValue = parseFloat(removeSpaces($(this).val() || 0));
    let fromValue = Math.min(parseFloat(removeSpaces($inputFrom.val() || 0)), sliderMaxValue);
    let toValue = Math.min(parseFloat(removeSpaces($inputTo.val() || 0)), sliderMaxValue);

    const isFrom = $(this).hasClass("js-range-from");
    const isTo = $(this).hasClass("js-range-to");

    if (isFrom) {
        fromValue = Math.min(inputValue, sliderMaxValue);
    }
    if (isTo) {
        toValue = Math.min(inputValue, sliderMaxValue);
    }

    // Проверка на корректность диапазона
    if (fromValue > toValue) {
        if (isFrom) {
            toValue = fromValue;
        } else {
            fromValue = toValue;
        }
    }

    $inputFrom.val(formatTextWithSpaces(fromValue));
    $inputTo.val(formatTextWithSpaces(toValue));
    if (range) {
        range.update({ from: fromValue, to: toValue });
    }
});
function initRangeSlider($input) {
    const $rangeWrap = $input.closest(".js-filter-block");
    const $rangeFrom = $rangeWrap.find(".js-range-from");
    const $rangeTo = $rangeWrap.find(".js-range-to");
    const minValue = $input.data("min");
    const maxValue = $input.data("max");
    const $filterPrice = $rangeWrap.find(".js-filter-price");

    $rangeFrom.val(formatTextWithSpaces($rangeFrom.val()));
    $rangeTo.val(formatTextWithSpaces($rangeTo.val()));
    $input.ionRangeSlider({
        type: "double",
        min: minValue,
        max: maxValue,
        from: removeSpaces($rangeFrom.val()),
        to: removeSpaces($rangeTo.val()),
        grid: false,
        hide_min_max: true,
        hide_from_to: true,
        skin: "round",
        onChange: function (data) {
            $rangeFrom.val(formatTextWithSpaces(data.from));
            $rangeTo.val(formatTextWithSpaces(data.to));

            rangeInputChanged = data.from > minValue || data.to < maxValue;

            App.lastCatalogChangedLine = $filterPrice;
        },
        onFinish: function () {
            setFilterStickyButtonPosition(App.lastCatalogChangedLine);
            updateCatalogFilter();
        },
    });
}

function formatTextWithSpaces(text) {
    let cleanedText = removeSpaces(text);
    return (
        cleanedText
            .split("")
            .reverse()
            .join("")
            .match(/.{1,3}/g) // Разбиваем по 3 символа
            ?.join(" ")
            .split("")
            .reverse()
            .join("") || ""
    );
}

function removeSpaces(text) {
    return text.toString().replace(/\s/g, ""); // Убираем все пробелы
}

function serializeFormData(formSelector) {
    const formData = $(formSelector).serializeArray();
    const filteredData = [];
    const initialCopy = [...initialFormValues];

    // Получаем все имена полей с классами js-range-from или js-range-to
    const rangeInputs = $(formSelector)
        .filter(".js-range-from, .js-range-to")
        .map((_, input) => input.name)
        .get();

    formData.forEach(function (field) {
        const $input = $(formSelector).find(`[name="${field.name}"]`);
        let value = field.value;
        const isRange = $input.is(".js-range-from, .js-range-to") || rangeInputs.includes(field.name);

        if (isRange) {
            value = removeSpaces(value);
        }

        // Пытаемся найти такую же пару name+value
        const matchIndex = initialCopy.findIndex(
            (f) => f.name === field.name && removeSpaces(f.value) === value,
        );
        if (matchIndex === -1) {
            filteredData.push({
                name: field.name,
                value,
            });
        } else {
            initialCopy.splice(matchIndex, 1);
        }
    });

    filteredData.forEach(function (field, index, arr) {
        const $input = $(formSelector)
            .find(`[name="${field.name}"]`)
            .filter(function () {
                return removeSpaces($(this).val()) === removeSpaces(field.value);
            });
        const isRangeFrom = $input.hasClass("js-range-from");
        const isRangeTo = $input.hasClass("js-range-to");

        if (!isRangeFrom && !isRangeTo) {
            return;
        }

        const siblingSelector = isRangeFrom ? ".js-range-to" : ".js-range-from";

        // Ищем ближайшего соседа с противоположным классом в пределах общего контейнера
        const $sibling = $input
            .parent()
            .find(siblingSelector)
            .not($input) // исключаем сам $input
            .first(); // если вдруг таких несколько

        if ($sibling.length === 0) {
            return;
        }

        const siblingName = $sibling.attr("name");
        const siblingValue = removeSpaces($sibling.val());

        const alreadyInData = filteredData.some(
            (f) => f.name === siblingName && removeSpaces(f.value) === siblingValue,
        );

        if (!alreadyInData) {
            const insertIndex = isRangeFrom ? index + 1 : index;

            arr.splice(insertIndex, 0, {
                name: siblingName,
                value: siblingValue,
            });
        }
    });

    return $.param(filteredData);
}

App.document.ready(function () {
    saveInitialFormValues();

    // Обновляем фильтры при загрузке страницы и наличии GET параметров
    if (window.location.search && $(".js-filter").length) {
        setTimeout(function () {
            updateCatalogFilter();
        }, 100);
    }
});
// Сохраняем начальные значения всех полей формы
function saveInitialFormValues() {
    // Исключение полей по имени
    const excludeInitialFieldNames = [];
    const $form = $(".js-filter");

    if ($(".js-filter-city").length) {
        excludeInitialFieldNames.push($(".js-filter-city input")[0].name);
    }

    // Исключение для поля "Только с пробегом"
    if ($(".js-filter-checkbox input[name=\"is_with_mileage\"]").length) {
        excludeInitialFieldNames.push($(".js-filter-checkbox input[name=\"is_with_mileage\"]")[0].name);
    }

    $form.find("input, select, textarea").each(function () {
        const $field = $(this);
        const name = $field.attr("name");
        const type = $field.attr("type");
        const value = removeSpaces($field.prop("value"));

        if (!name || excludeInitialFieldNames.includes(name)) return;

        const isCheckable = type === "checkbox" || type === "radio";

        if (!isCheckable || $field.prop("checked")) {
            initialFormValues.push({ name, value });
        }
    });
}

let filterStickyButtonTimeout;
let $filterStickyButton;

export function setFilterStickyButtonPosition($buttonWrapper) {
    if (!$filterStickyButton) {
        $filterStickyButton = $(".js-sticky-filter-submit");

        // Скрываем плавающую кнопку Применить
        $filterStickyButton
            .on("mouseenter", function () {
                clearTimeout(filterStickyButtonTimeout);
            })
            .on("mouseleave", function () {
                filterStickyButtonTimeout = setTimeout(() => {
                    $filterStickyButton.removeClass("_shown");
                }, 2000);
            });
    }

    const filterContentTop = $(".js-filter-content").offset().top;

    // Показываем плавающую кнопку Применить
    const filterStickyButtonPosition = $buttonWrapper.offset().top - filterContentTop + $buttonWrapper.innerHeight() / 2;

    clearTimeout(filterStickyButtonTimeout);
    filterStickyButtonTimeout = setTimeout(() => {
        $filterStickyButton.removeClass("_shown");
    }, 2000);

    $filterStickyButton.css("top", filterStickyButtonPosition).addClass("_shown");
}
